export default __webpack_public_path__ + "static/media/ic_thick_plus_primary.7f3973ab.svg";